import React from 'react';

import { useNavigate } from 'react-router-dom';

import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';
import { isExternalLink } from 'utils/is-external-link';
import { redirect } from 'utils/routing';

import {
  Description,
  DescriptionBlockRenderer,
  ImageContainer,
  InfoContainer,
  TileContainer,
  TileImg,
  Title,
} from './styled';
import { ITileElementProps } from './types';

export const TileElement: React.FC<ITileElementProps> = ({
  title,
  description,
  image,
  imageDescription,
  url,
  id,
}) => {
  const navigate = useNavigate();
  const mParticle = useMParticleContext();

  let descriptionEl = null;
  if (description) {
    descriptionEl =
      typeof description === 'string' ? (
        <Description>{description}</Description>
      ) : (
        <DescriptionBlockRenderer content={description} />
      );
  }

  const handleRedirect = () => {
    mParticle.trackEvent({
      name: CustomEventNames.MARKETING_TILE_CAROUSEL,
      type: EventTypes.Other,
      attributes: {
        'Marketing Tile Carousel': id,
      },
    });

    if (!url) {
      return;
    }

    if (isExternalLink(url)) {
      redirect(url);
    } else {
      navigate(url);
    }
  };

  return (
    <TileContainer onClick={handleRedirect}>
      <ImageContainer>
        {image && <TileImg image={image} alt={imageDescription || ''} objectFitContain />}
      </ImageContainer>
      <InfoContainer>
        <Title>{title}</Title>
        {descriptionEl}
      </InfoContainer>
    </TileContainer>
  );
};
